import { internalSites } from '@canvas/constants/environment/sites-internal';
import { Deferrable } from '@canvas/deferrable';
export {
  currentFeatureFlagState,
  defaultFeatureFlagState,
  FeatureFlagSource,
  isFeatureFlagEnabled,
  isFeatureFlagName,
  resetFeatureFlagState,
  resolvedFeatureFlagState,
  setFeatureFlagOverride,
  TargetApp,
  type ClientFeatureFlag,
  type ClientFeatureFlagName,
  type ClientFeatureFlags,
  type FeatureFlagOverrides,
} from '@canvas/client-feature-flags-state';

/**
 * Use this sparingly. Only to be used in cases where you truly, permanently want to allow a feature to be
 * used by the internal Atlassians (E.g. Showing banners, etc)
 */
export const isInternalSite = () =>
  internalSites
    .map((site) => site.hostname.toLowerCase())
    .concat(['canvas.localhost'])
    .includes(new URL(globalThis.location.href).hostname.toLowerCase());

export const statsigClientInitalized = new Deferrable();

/**
 * A promise which resolves when the feature flag state has been initialized.
 * This will be resolved when both feature flag clients are ready.
 */
export const featureFlagsInitialized = statsigClientInitalized.get();
